import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const FinishButton = styled(ButtonMui)`
  height: 3.5em;
  width: 16rem;
`

export const ButtonContainer = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: flex-end;
  margin-top: 2em;
`
